import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import VisitSectionStatus from './VisitSectionStatus';

export const WORKSPACE_SECTIONS = [
  { key: 'history', label: 'History' },
  { key: 'examination', label: 'Examination' },
  { key: 'investigations', label: 'Investigations' },
  { key: 'prescription', label: 'Prescription' },
];

function TabLabel({ label, status }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <span>{label}</span>
      <VisitSectionStatus status={status} compact />
    </Box>
  );
}

export default function VisitWorkspaceTabs({ section, statuses = {}, onChange }) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', overflowX: 'auto' }}>
      <Tabs
        value={section}
        onChange={(_event, value) => onChange(value)}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Visit clinical sections"
      >
        {WORKSPACE_SECTIONS.map((item) => (
          <Tab
            key={item.key}
            value={item.key}
            label={<TabLabel label={item.label} status={statuses[item.key]} />}
          />
        ))}
      </Tabs>
    </Box>
  );
}
